function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 2.204c-.735-1.05-1.787-1.047-2.837-.313L7.77 5.669 5.664 4.202A2.967 2.967 0 104.622 5.43l1.987 1.392-2.113 1.48A2.964 2.964 0 105.6 9.483l2.168-1.51 5.394 3.778c1.05.735 2.102.736 2.837-.313L9.405 6.82 16 2.204zM2.964 4.444a1.476 1.476 0 110-2.953 1.476 1.476 0 010 2.953zm0 7.876a1.476 1.476 0 110-2.953 1.476 1.476 0 010 2.953z",
  fill: "#676D75"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none"
  }, props), _ref);
};

export default SvgComponent;